export const ITEMS_PER_PAGE_ACTION = 10;
export const AHS_AND_HSA = 'AHS_HSA';
export const FRONTDOOR_GIFT_UNLIMITED_URL =
  'https://www.frontdoor.com/real-estate/?utm_source=re-agent&utm_medium=portal&utm_campaign=general';
